import { render } from "./PremiumUpsellModal.vue?vue&type=template&id=66e62861&scoped=true"
import script from "./PremiumUpsellModal.vue?vue&type=script&lang=js"
export * from "./PremiumUpsellModal.vue?vue&type=script&lang=js"

import "./PremiumUpsellModal.vue?vue&type=style&index=0&id=66e62861&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e62861"]])

export default __exports__